module.exports = __webpack_public_path__ + "static/media/sort-arrow.402244f6.svg";